import createIcon from '../../createIcon';

/**
 * @component @name PunchClock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNi41SDE4VjEuNUg2VjYuNUg1QzMuOSA2LjUgMyA3LjQgMyA4LjVWMjAuNUMzIDIxLjYgMy45IDIyLjUgNSAyMi41SDE5QzIwLjEgMjIuNSAyMSAyMS42IDIxIDIwLjVWOC41QzIxIDcuNCAyMC4xIDYuNSAxOSA2LjVaTTggMy41SDE2VjYuNUg4VjMuNVpNMTIgMTkuNUM5LjI0IDE5LjUgNyAxNy4yNiA3IDE0LjVDNyAxMS43NCA5LjI0IDkuNSAxMiA5LjVDMTQuNzYgOS41IDE3IDExLjc0IDE3IDE0LjVDMTcgMTcuMjYgMTQuNzYgMTkuNSAxMiAxOS41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyLjUgMTJIMTEuNVYxNC43MUwxMy4xNCAxNi4zNUwxMy44NSAxNS42NEwxMi41IDE0LjI5VjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PunchClock = createIcon('PunchClock', [
  [
    'path',
    {
      d: 'M19 6.5H18V1.5H6V6.5H5C3.9 6.5 3 7.4 3 8.5V20.5C3 21.6 3.9 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V8.5C21 7.4 20.1 6.5 19 6.5ZM8 3.5H16V6.5H8V3.5ZM12 19.5C9.24 19.5 7 17.26 7 14.5C7 11.74 9.24 9.5 12 9.5C14.76 9.5 17 11.74 17 14.5C17 17.26 14.76 19.5 12 19.5Z',
      key: 'hcdh2q',
    },
  ],
  ['path', { d: 'M12.5 12H11.5V14.71L13.14 16.35L13.85 15.64L12.5 14.29V12Z', key: 'kfkapa' }],
]);

export default PunchClock;
